// lib/list/factoryGenerationLimits.ts
export const MAX_FACTORY_OUTPUTS = 12;
